import { render, staticRenderFns } from "./InvoiceTotalRow.vue?vue&type=template&id=464a7dbd&scoped=true&"
import script from "./InvoiceTotalRow.vue?vue&type=script&lang=js&"
export * from "./InvoiceTotalRow.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTotalRow.vue?vue&type=style&index=0&id=464a7dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a7dbd",
  null
  
)

export default component.exports